








































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { refsService } from '@/app/shared/refs.service';
import { InstallmentModel } from '@/app/shared/models';
import TextMoney from '@/app/shared/components/text-money/text-money.vue';

@Component({ components: { TextMoney } })
export default class DataTabeInstallmentsComponent extends Vue {
  @Prop(Array) readonly data!: InstallmentModel[];
  @Prop(Boolean) readonly edit!: boolean;
  @Prop(Boolean) readonly attempt!: boolean;
  @Prop(Function) readonly onChangeValue!: Function;

  private headers: DataTableHeader[] = [];
  private loading = false;
  private menu = false;
  public yearMonthReferenceMenu = false;
  public editing = 0;
  public newValue = 0;
  private newData: InstallmentModel[] = [];
  private get refs() {
    return refsService;
  }
  public diffValueRefunds(item: InstallmentModel): number {
    const listRefunds = this.refs.modules.contract.refundsByContract;
    const totalValueRefunds: number = listRefunds
      .filter((refund) => refund.InstallmentId == item.Id)
      .reduce((a, b) => a + b.Value, 0);
    item.TotalValueRefunds = totalValueRefunds;
    return (item.Value || 0) - (item.TotalValueRefunds || 0);
  }

  public checkShowPencil(item: InstallmentModel): boolean {
    return this.diffValueRefunds(item) > 0;
  }
  public checkValues(
    inputValue: string,
    valueTotal: number,
    checkZero?: boolean
  ): boolean {
    if (!inputValue) {
      return false;
    }
    const valueParse = Number(inputValue.replace(',', '.'));
    if (!valueParse) {
      return false;
    }
    if (!checkZero) {
      return valueParse <= valueTotal;
    }
    return valueParse != 0;
  }
  public onChange(value: number) {
    this.newValue = value;
  }
  public saveChanges(itemNumber: number) {
    this.data.forEach((item) => {
      if (itemNumber == item.Number) {
        if (item.Value && this.diffValueRefunds(item) >= this.newValue) {
          item.PartialValue = this.newValue;
        }
      }
    });
    this.onChangeValue();
    this.newValue = 0;
    this.editing = 0;
    this.$emit('onEdit', true);
  }

  private startEdit(item: number) {
    this.editing = item;
    if (item > 0) this.$emit('onEdit', true);
    else this.$emit('onEdit', false);
  }

  @Watch('data')
  private async loadNewData(): Promise<void> {
    this.newData = [];
    const checkPartialRefund = await this.refs.modules.contract.verifyPartialRefundByInstallmentId(
      this.data.map((item) => item.Id)
    );
    if (checkPartialRefund) {
      this.data.forEach((item) => {
        const index = checkPartialRefund.findIndex(
          (elem) => elem.InstallmentId == item.Id
        );
        if (index > -1) {
          item.ProcessorPartialRefund =
            checkPartialRefund[index].ProcessorPartialRefund;
        }
      });
    }
    this.newData = this.data;
  }

  private async created(): Promise<void> {
    this.headers = [
      { text: this.$t('headers.status').toString(), value: 'Status' },
      {
        text: this.$t('headers.installment').toString(),
        value: 'Number',
      },
      {
        text: this.$t('headers.attempts').toString(),
        value: 'CurrentAttemptNumber',
      },
      {
        text: this.$t('headers.integration_identifier').toString(),
        value: 'OurCode',
      },
      {
        text: this.$t('headers.installment_maturity').toString(),
        value: 'OriginalDueDate',
      },
      {
        text: this.$t('headers.reference').toString(),
        value: 'MonthReference',
      },
      { text: this.$t('headers.value').toString(), value: 'Value' },
    ];
    await this.loadNewData();
  }
}
